import { ca } from '@cian/analytics';
import { TLabel } from '../../types/auth';

export function trackPhoneFormFailed(label: TLabel) {
  ca('eventSite', {
    action: 'fail',
    label,
    category: 'Mortgage',
    name: 'oldevent',
  });
}
